import React from 'react'
import './Accessibilty.css'

const AccessibiltyEn = () => {
  return (
    <div style={{direction:"ltr"}} className='accessibilty-container'>
       <h1>Accessibility Statement OPEN DATA website of the Tel Aviv Jaffa</h1> 
<p>The Tel Aviv-Jaffa Municipality is committed to making our websites as accessible as possible for everyone including people with disabilities.
On the OPEN DATA website's accessibility adjustments were made as required, in accordance with the Equal Rights for Persons with Disabilities Regulations (Accessibility Adjustments to the Service) 2013, SI 5568 – " Web Content Accessibility Guidelines" and W3C's Web Content Accessibility Guidelines 2.0, level AA.
Measures to support accessibility:
Each repository has several views:</p>
<ul>
    <ol>Information - textual information about the database</ol>
    <ol>Table - To obtain the data in an accessible way for screen readers and keyboard users, it is recommended to download the Excel file to the computer by clicking on the link "Open the table in the Excel file."</ol>
    <ol>Charts - The charts are displayed using a system in Microsoft's PowerBI system. To reach the chart area with the keyboard, press TAB until the chart area is marked with black frame, press CRTL + ENTER, in the menu that opens, go with TAB to the "Skip to page content" link and press ENTER. The focus will move to the filter area. At any stage you can press the "?" Key For keyboard shortcuts.
        <ul>
            <li>Learn more about keyboard navigation.</li>
            <li>Watch a demo video for browsing charts using a keyboard.</li>
        </ul>
    </ol>
    <ol>API - Link to API code for interface to the database</ol>
    <ol>	Map - To receive the map in an accessible way for screen readers and keyboard users, it is recommended to open the map in a new window in the municipal GIS system by clicking on the link "Open a map in a new window."</ol>
</ul>

Limitations and alternatives
Despite our best efforts to ensure accessibility, there may be some limitations. Below is a description of known limitations, and potential solutions. Please contact us if you observe an issue not listed below. Accessibility restrictions:
<ul>
    <li>The site uses Microsoft's PowerBI system to display charts. Browsers supported by PowerBI are Chrome or Edge. Accessibility is not supported in mobile view.</li>
    <li>It should be noted that a screen reader works well with the system however it responds slowly it is recommended to wait patiently for the reading after each navigation operation with the keyboard.</li>
</ul>

The site is tested with a Chrome browser and a JAWS screen reader, the chart area on the site is tested according to Microsoft instructions for using the keyboard.
Feedback
We welcome your feedback on the accessibility of Open Data site. Please contact Tel Aviv Jaffa Accessibility coordinator
Date of updating the accessibility statement: 05.01.2021

    </div>
  )
}

export default AccessibiltyEn